import Axios from 'axios';
import Api from './Api';
const END_POINT = 'analysis';



export default {
    async get_all(filters = null) {      
      let request = {
        params: filters
      }
      return await Api.get(`${END_POINT}`, request);
    },
    async get_allPaginated(filters = null) {
      let request = {
          params: filters
      }
      return await Api.get(`${END_POINT}-list-paginated`, request);
    },
    async store(analysis) {
        return await Api.post(`${END_POINT}`, analysis);
    },
    async update(analysis) {
        return await Api.patch(`${END_POINT}/${analysis.id}`, analysis);
    },
    async change_status(analysis) {
        return await Api.patch(`${END_POINT}/${analysis.id}/change-status`, analysis);
    },
    async delete(analysis) {
        return await Api.delete(`${END_POINT}/${analysis.id}`, analysis);
    },
    async uploadAnalysisService(analysis) {
        const config = {
          headers: {
            "content-type": "multipart/form-data",
          },
        };
        return Api.post(`${END_POINT}/uploadAnalysisService`, analysis, config);
    },
    async analysisExcel(filters = null) {
      let request = {
          params: filters
      }
      return await Api.get(`${END_POINT}/analysis-export`, request);
  },
}